import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName } from '../security.module';

/**
 * The Project Jobs addon: entitles a tenant to create Project (gantt) jobs. A plan switch only, so it
 * declares no rights. Unrelated to the retired standalone Projects screen module it replaces on the Plan page.
 */
export class ProjectJobsSecurityModule extends BaseSecurityModule<never> {

    constructor() {
        super(SecurityModuleName.ProjectJobs, []);

        this.plan = TenantSubscription.Custom;
    }

}
